export const CHANGE_DELIVERY_DATE_SELECTOR_VISIBILITY = 'CHANGE_DELIVERY_DATE_SELECTOR_VISIBILITY';
export const CHANGE_DELIVERY_DATE_SELECTED = 'CHANGE_DELIVERY_DATE_SELECTED';